import React from "react";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";

const Landing = () => {
  const [isWorkspaceIdPresent, setIsWorkspaceIdPresent] = useState(false);

  useEffect(() => {
    const workspaceId = Cookies.get("workspaceId");
    if (workspaceId) {
      setIsWorkspaceIdPresent(true);
    }
  }, []);
  return (
    <div className="flex flex-col justify-center items-center min-h-screen">
      <div className="w-2/3 text-center">
      <h1 className="text-5xl md:text-6xl font-bold uppercase leading-snug tracking-wide">
          <span className="text-orange-500">Citrana AI</span>
        </h1>

        <h1 className="text-5xl md:text-6xl font-bold uppercase leading-snug tracking-wide">
           
          Research Smarter and Launch with Confidence {" "}
        </h1>

        <p className="mt-6 text-lg md:text-xl w-2/3 mx-auto">
        Citrana is an AI-powered platform that provides startups with market insights, 
        competitor analysis, and customer feedback for any product idea. 
        Simply enter your concept, and our platform delivers tailored research to help refine your product and ensure market success.
        </p>

        <div className="mt-8 flex gap-8 justify-center">
          <button
            className="bg-black hover:bg-white transition-all hover:text-black outline outline-1 text-white py-4 px-24 rounded-full text-xl font-semibold"
            onClick={() => {
              window.location.href = "/enter-idea";
            }}
          >
            New Business Idea
          </button>
          <button
            className=" hover:bg-black hover:text-white text-black transition-all outline outline-1 py-3 px-12 rounded-full text-xl"
            onClick={() => {
              window.location.href = "/workspaces";
            }}
            // disabled={!isWorkspaceIdPresent}
          >
            Browse Old Ideas
          </button>
        </div>
      </div>
    </div>
  );
};

export default Landing;
